import React from 'react';
import '../styles/workoutCards.css';
import { formatToDayMonth } from '@utility/common_utils'

export const WorkoutCard = ({ session }) => {
  const formatDurationcomplete = (duration) => {
    const days = Math.floor(duration / (60 * 24)); 
    const hours = Math.floor((duration % (60 * 24)) / 60);
    const mins = duration % 60;
  
    if (days !== 0) {
      return `${days}d:${String(hours).padStart(2, '0')}h:${String(mins).padStart(2, '0')}m`;
    } else if (hours !== 0) {
      return `${hours}h:${String(mins).padStart(2, '0')}m`;
    } else {
      return `${mins}m`;
    }
  };

  const renderTimeBlock = (session) => {
    const date = new Date(session.session_date);
    const startHour = date.getHours();
    const startMinute = date.getMinutes();
    const duration = session.duration || 0;
    
    const startPercentage = (startHour * 60 + startMinute) / 1440 * 100;
    const durationPercentage = duration / 1440 * 100;
    
    return (
      <div className="workout-timeline">
        <div 
          className="workout-time-block"
          style={{
            left: `${startPercentage}%`,
            width: `${durationPercentage}%`
          }}
        />
      </div>
    );
  };

  return (
    <div className="workout-card">
      <div className="workout-header">
        <h3>{session.session_name}</h3>
        <span className="workout-date">
          {new Date(session.session_date).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </span>
      </div>
      <div className="workout-meta">
        <p className="workout-date">{formatToDayMonth(session.session_date)}</p>
        <p className="workout-duration">{formatDurationcomplete(session.duration) || 0}</p>
      </div>
      {renderTimeBlock(session)}

      <div className="exercises">
        {session.exercises.map(exercise => (
          <div key={exercise.id} className="exercise">
            <h4>{exercise.exercise_name}</h4>
            <ul>
              {exercise.sets.map((set, i) => (
                <li key={i}>
                  <span className="set-weight">{set.weight}kg</span>
                  <span className="set-multiply">×</span>
                  <span className="set-reps">{set.reps}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export const WorkoutList = ({ sessions }) => {
  return (
    <div className="workout-list">
      {sessions.slice().reverse().map(session => (
        <WorkoutCard key={session.id} session={session} />
      ))}
    </div>
  );
};

export const DaySummaryStats = ({ dayData }) => {
  const formatDurationValue = (duration) => {
    const days = Math.floor(duration / (60 * 24));
    const hours = Math.floor((duration % (60 * 24)) / 60);
    const mins = duration % 60;
  
    if (days !== 0) {
      return `${days}:${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    } else if (hours !== 0) {
      return `${hours}:${String(mins).padStart(2, '0')}`;
    } else {
      return `${mins}`;
    }
  };
  
  const formatDurationLabel = (duration) => {
    const days = Math.floor(duration / (60 * 24));
    const hours = Math.floor((duration % (60 * 24)) / 60);
  
    if (days !== 0) {
      return "days:hours:mins";
    } else if (hours !== 0) {
      return "hours:mins";
    } else {
      return "mins";
    }
  };

  return (
    <div className="day-summary-stats">
      <div className="summary-stat">
        <span className="stat-value">{dayData.sessions}</span>
        <span className="stat-label">Workouts</span>
      </div>
      <div className="summary-stat">
        <span className="stat-value">{formatDurationValue(dayData.duration)}</span>
        <span className="stat-label">{formatDurationLabel(dayData.duration)}</span>
      </div>
      <div className="summary-stat">
        <span className="stat-value">{dayData.sets}</span>
        <span className="stat-label">Sets</span>
      </div>
      <div className="summary-stat">
        <span className="stat-value">{Math.round(dayData.volume)}</span>
        <span className="stat-label">Volume (kg)</span>
      </div>
    </div>
  );
};